import React, {useEffect, useState, useRef} from 'react';
import {Grid, Typography} from "@mui/material";

import {connect} from "react-redux";
import { CompDatePickerNew } from '../../../../components/newComponents/DatePickerNew';
import CustomSnackbar from '../../../../components/CustomSnackbar';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { ButtonPrimary } from '../../../../components/newComponents/ButtonPrimary';
import {ButtonSpacer} from "../../../../components/ButtonSpacer";
import { CompDropdownNew } from '../../../../components/newComponents/DropdownNew';
import {
    CalendarToday as CalendarTodayIcon,
  } from "@mui/icons-material";
import {CompFunctionCards} from "../../components/FunctionCards";
import {
    listFunctions,
    createFunction,
    setFunctions,
    getSortedLocations
} from "../../function.actions";
import { askUpdates } from "../../../root/root.actions";
import {listLocations} from "../../../location/location.actions";
import {withTranslation} from "react-i18next";
import {
    getMunicipality,
    listMunicipalities,
} from "../../../municipality/municipality.actions";
import { ButtonSecondary } from '../../../../components/newComponents/ButtonSecondary';
import {
    hasPermission, hasPermissionToHandleMunicipality,
    PERMISSION_CREATE_FUNCTION_BEHALF_OF_ANOTHER,
    PERMISSION_CREATE_FUNCTION_TEMPLATE,
    PERMISSION_CREATE_OWN_FUNCTION, PERMISSION_EDIT_ANY_FUNCTIONS, PERMISSION_EDIT_OWN_FUNCTIONS
} from "../../../../permissions";
import {CompRadioGroup} from "../../../../components/RadioGroup";
import {CompTextFieldNew} from "../../../../components/newComponents/TextField";

const mapStateToProps = (state) => {
    return {
        municipalities: state.municipality.municipalities,
        selectedFunction: state.func.selectedFunction,
        selectedMunicipality: state.municipality.selectedMunicipality,
        selectedOrganization: state.municipality.selectedOrganization,
        selectedLocation: state.location.selectedLocation,
        locations: state.location.locations,
        organizations: state.municipality.organizations,
        functionFieldErrors: state.func.functionFieldErrors,
        authenticatedUser: state.auth.authenticatedUser,
        userSettings: state.user.userSettings,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        askUpdates: () => dispatch(askUpdates()),
        listMunicipalities: () => dispatch(listMunicipalities()),
        getMunicipality: (id) => dispatch(getMunicipality(id)),
        createFunction: (data, createTemplate, onSuccess, onlyTemplate) => dispatch(createFunction(data, createTemplate, onSuccess, onlyTemplate)),
        listFunctions: (filters, onSuccess) => dispatch(listFunctions(filters, onSuccess)),
        listLocations: (municipalityId) => dispatch(listLocations(municipalityId)),
        getSortedLocations: (locations, organizations, authenticatedUser, randomLocation) => getSortedLocations(locations, organizations, authenticatedUser, randomLocation)
    };
}

const FunctionPage = (props) => {
    const {t} = props;
    const searchInputRef = useRef();

    const searchTimerRef = useRef(null);

    const location = useLocation()
    const [snackbarOpen, setSnackbarOpen] = React.useState(location.state?.showSuccess || false);
    const [isTemplateCreated, setIsTemplateCreated] = useState(location.state?.isTemplate || false)
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();

    const [state, setState] = useState({
        functions: [],
        functionType: searchParams.get("functionType") || "all",
        locationId: parseInt(searchParams.get("locationId")) || -1,
        currentMunicipality: parseInt(searchParams.get("currentMunicipality")) || props.selectedMunicipality.id,
        limit: parseInt(localStorage.getItem("rowsPerPage")) || 10,
        offset: parseInt(searchParams.get("offset")) || 0,
        startDate: searchParams.get("startDate") || null,
        endDate: searchParams.get("endDate") || null,
        filter: searchParams.get("filter") || "", 
        activeTab: searchParams.get("activeTab") || (props.userSettings && props.userSettings.defaultEventView === "your_functions" ? "yourFunctions" : "history")
    });

    useEffect(() => {
        const params = {};
        
        if (state.functionType !== "all") params.functionType = state.functionType;
        if (state.locationId !== -1) params.locationId = state.locationId;
        if (state.currentMunicipality !== props.selectedMunicipality.id) params.currentMunicipality = state.currentMunicipality;
        if (state.startDate) params.startDate = state.startDate;
        if (state.endDate) params.endDate = state.endDate;
        if (state.filter) params.filter = state.filter;
        if (state.offset > 0) params.offset = state.offset;
        
        const defaultTab = props.userSettings && props.userSettings.defaultEventView === "your_functions" ? "yourFunctions" : "history";
        if (state.activeTab !== defaultTab) params.activeTab = state.activeTab;

        setSearchParams(params, { replace: true });

    }, [
        state.functionType, state.locationId, state.currentMunicipality, 
        state.startDate, state.endDate, state.filter, state.offset, state.activeTab, 
        props.selectedMunicipality.id, props.userSettings, setSearchParams
    ]);

    const createListFunctionFilterObject = () => {
        return {
            municipalityId: state.currentMunicipality,
            functionType: state.functionType,
            startDate: state.startDate,
            endDate: state.endDate,
            rows: state.rowsPerPage,
            limit: state.limit,
            offset: state.offset,
            filter: state.filter,
            locationId: state.locationId,
            own: state.activeTab === 'yourFunctions' ? true : null
        }
    }
    
    useEffect( () => {
        props.askUpdates();
        props.listMunicipalities();
        props.listLocations(props.selectedMunicipality.id);
        props.getMunicipality(props.selectedMunicipality.id)
    }, [])

    useEffect(() => {
        callListFunctions(null, null, null, null, null, parseInt(localStorage.getItem("rowsPerPage")) || 10);
    }, [state.activeTab]);

    const callListFunctions = (municipalityId = null, functionType = null, startDate = null, endDate = null, offset = null, limit = null) => {
        if (searchTimerRef.current) {
            clearTimeout(searchTimerRef.current)
        }
        var filters = createListFunctionFilterObject();
        filters.municipalityId = municipalityId ? municipalityId : props.selectedMunicipality.id;
        filters.functionType = functionType ? functionType : (filters.functionType ? filters.functionType : "all");
        filters.organizerId = state.activeTab === 'yourFunctions' ? props.authenticatedUser.id : undefined;
        if (startDate) filters.startDate = startDate;
        if (endDate) filters.endDate = endDate;
        if (offset) filters.offset = offset;
        if (limit) filters.limit = limit;

        if (filters.own === true && props.selectedMunicipality.id !== props.authenticatedUser.mainMunicipalityId) {
            handleMunicipalityChange({
                target: {
                    value: props.authenticatedUser.mainMunicipalityId
                }
            });
        }
        else {
            props.listFunctions(filters, (data) => {
                setState(offset != null ? {...state, functions: data, offset: offset} : {...state, functions: data});
                return setFunctions(data);
            });
        }
    }

    const changePage = (forwards = true) => {
        var offset = state.offset;

        if (forwards) {
            offset = offset + state.limit
        }
        else {
            offset = offset - state.limit
            if (offset < 0) offset = 0
        }

        if (offset === state.offset) {
            return;
        }

        var filters = createListFunctionFilterObject();
        filters.offset = offset;
        props.listFunctions(filters, (data) => {
            setState(prevState => ({
                ...prevState,
                offset: offset,
                functions: data
            }));
            return setFunctions(data);
        });
    }

    const getMunicipalityOptions = () => {
        const response = [];
        props.municipalities.forEach((municipality) => {
            response.push({value: municipality.id, label: municipality.name})
        });
        response.sort((a,b) => a.label.localeCompare(b.label));
        return response;
    }

    // municipalityId, functionType, startDate, endDate, filter, rows,
    const handleMunicipalityChange = (e) => {
        if (searchTimerRef.current) {
            clearTimeout(searchTimerRef.current)
        }
        const val = e.target.value;

        setState(prevState => ({
            ...prevState,
            offset: 0,
            currentMunicipality: val,
            locationId: -1,
        }));

        props.getMunicipality(val);
        props.listLocations(val); 

        var filters = createListFunctionFilterObject();
        filters.municipalityId = val;
        filters.locationId = -1;
        
        props.listFunctions(filters, (data) => {
            setState(prevState => ({
                ...prevState,
                functions: data
            }));
            return setFunctions(data);
        });
    }

    const handleFunctionTypeChange = (e) => {
        if (searchTimerRef.current) {
            clearTimeout(searchTimerRef.current)
        }
        const val = e.target.value;
        var filters = createListFunctionFilterObject();
        filters.functionType = val;
        filters.organizerId = state.activeTab === 'yourFunctions' ? props.authenticatedUser.id : undefined;
        props.listFunctions( filters, (data) => {
            setState({
                ...state,
                offset: 0,
                functionType: val,
                functions: data
            });
            return setFunctions(data);
        });
    }

    const handleLocationChange = (e) => {
        if (searchTimerRef.current) {
            clearTimeout(searchTimerRef.current)
        }
        const val = e.target.value;

        setState(prevState => ({
            ...prevState,
            offset: 0,
            locationId: val
        }));

        var filters = createListFunctionFilterObject();
        filters.locationId = val;
        filters.organizerId = state.activeTab === 'yourFunctions' ? props.authenticatedUser.id : undefined;

        props.listFunctions(filters, (data) => {
            setState(prevState => ({
                ...prevState,
                functions: data
            }));
            return setFunctions(data); 
        });
    }

    const handleDateChangeStart = (e) => {
        if (searchTimerRef.current) {
            clearTimeout(searchTimerRef.current)
        }
        const val = e.target.value;
        var filters = createListFunctionFilterObject();
        filters.startDate = val;
        filters.organizerId = state.activeTab === 'yourFunctions' ? props.authenticatedUser.id : undefined;
        props.listFunctions( filters, (data) => {
            setState({
                ...state,
                offset: 0,
                startDate: val,
                functions: data
            });
            return setFunctions(data);
        });
    }

    const handleDateChangeEnd = (e) => {
        if (searchTimerRef.current) {
            clearTimeout(searchTimerRef.current)
        }
        const val = e.target.value;
        var filters = createListFunctionFilterObject();
        filters.endDate = val;
        filters.organizerId = state.activeTab === 'yourFunctions' ? props.authenticatedUser.id : undefined;
        props.listFunctions( filters, (data) => {
            setState({
                ...state,
                offset: 0,
                endDate: val,
                functions: data
            });
            return setFunctions(data);
        });
    }

    const handleFilterChange = (e) => {
        const val = e.target.value;
        var filters = createListFunctionFilterObject();
        filters.filter = val;
        setState({...state, filter: val})
        filters.organizerId = state.activeTab === 'yourFunctions' ? props.authenticatedUser.id : undefined;

        if (searchTimerRef.current) {
            clearTimeout(searchTimerRef.current)
        }

        searchTimerRef.current = setTimeout(() => {
            props.listFunctions( filters, (data) => {
                setState(prevState => ({
                    ...prevState,
                    offset: 0,
                    functions: data
                }));
                return setFunctions(data);
            });
        }, 1000)
    }

    const _getSortedLocations = (locations, organizations, authenticatedUser, name) => {
        var array = props.getSortedLocations(locations, organizations, authenticatedUser, name);
        array[0] = {id: -1, name: props.t('function.all')}

        return array;
    }

    const updateRowsPerPage = (rows) => {
        var filters = createListFunctionFilterObject();
        filters.limit = rows;
        props.listFunctions(filters, (data) => {
            setState(prevState => ({
                ...prevState,
                limit: rows,
                functions: data
            }));
            return setFunctions(data);
        });
    }

    const resetAll = (e) => {
        searchInputRef.current?.closeSearchList();
        var filters = createListFunctionFilterObject();
        filters.filter = null;
        filters.startDate = null;
        filters.endDate = null;
        filters.functionType = "all";
        filters.locationId = -1;
        filters.municipalityId = props.selectedMunicipality.id;
        filters.filter = null;
        filters.own = props.userSettings && props.userSettings.defaultEventView === "your_functions"

        props.listFunctions( filters, (data) => {
            setState({
                ...state,
                functions: data,
                filter: null,
                startDate: null,
                endDate: null,
                functionType: "all",
                locationId: -1,
                currentMunicipality: props.selectedMunicipality.id,
                offset: 0,
                activeTab: props.userSettings && props.userSettings.defaultEventView === "your_functions" ? "yourFunctions" : "history"
            })
            return setFunctions(data);
        });
    }


    //Function methods
    //changed to use react router history function as invalid data was sent to the components
    const handleCreateNew = (event) => {
        event.preventDefault()
        navigate('/function/createFunction')
    }

    const viewFunction = (event, data) => {
        event.preventDefault()
        if (data.shareEventId) {
            navigate('/function/createFunction/view-shared/' + data.shareEventId, data)
        }
        else {
            navigate('/function/createFunction/view/' + data.id, data)
        }

    }

    const editFunction = (event, data) => {
        event.preventDefault();
        if (data.shareEventId) {
            navigate('/function/createFunction/edit-shared/' + data.shareEventId, data);
        }
        else {
            navigate('/function/createFunction/edit/' + data.id, data);
        }
    }

    const copyFunction = (event, data) => {
        event.preventDefault()
        let copyData = {
            eventType: data.eventType,
            locationId: data.locationId,
            locationName: data.locationName,
            locationPostCode: data.locationPostCode,
            locationTypeId: data.locationTypeId,
            organizationId: data.organizationId,
            serviceId: data.serviceId,
            name: data.name,
            municipalityId: data.municipalityId,
            methods: structuredClone(data.methods),
            organizers: structuredClone(data.organizers),
            contentIdentifiers: structuredClone(data.contentIdentifiers),
            startDatetime: data.startDatetime, 
            endDatetime: data.endDatetime, 
            eventHours: data.eventHours
        }
        navigate('/function/createFunction/copy/' + data.id, copyData)
    }

    //Buttons
    let cardActionButtons = [], addButton = [];
    if((hasPermissionToHandleMunicipality(props.selectedMunicipality.id, props.authenticatedUser))
        && (hasPermission(PERMISSION_CREATE_FUNCTION_BEHALF_OF_ANOTHER, props.authenticatedUser) ||
            hasPermission(PERMISSION_CREATE_OWN_FUNCTION, props.authenticatedUser) ||
            hasPermission(PERMISSION_CREATE_FUNCTION_TEMPLATE, props.authenticatedUser))) {
       addButton.push(<ButtonPrimary startIcon={<CalendarTodayIcon />} key={'create_new_function'} color="primary" onClick={handleCreateNew}> {t('function.create_new_function')}</ButtonPrimary>);
    }
    if (hasPermission(PERMISSION_EDIT_ANY_FUNCTIONS, props.authenticatedUser) || hasPermission(PERMISSION_EDIT_OWN_FUNCTIONS, props.authenticatedUser)) {
        cardActionButtons.push({
                id: 'edit', label: t('common.edit'),
                icon: process.env.PUBLIC_URL + '/media/images/icons/IconPencil.svg',
                iconAlt: t('common.edit'), className: "editButton",
                onClick: editFunction
            });
        cardActionButtons.push({
                id: 'copy', label: t('common.copy_new'),
                icon: process.env.PUBLIC_URL + '/media/images/icons/IconPencil.svg',
                iconAlt: t('common.copy_new'), className: "editButton",
                onClick: copyFunction
            })
    }

    return (
        <div>
            <Grid container spacing={2} className="function-page-wrapper">
                <CustomSnackbar
                    open={snackbarOpen}
                    onClose={() => setSnackbarOpen(false)}
                    severity="success"
                    message={isTemplateCreated ? t('function.function_template_saved_success') : "Toiminta tallennettu onnistuneesti!"} //todo translations
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                />
                <Typography variant='h4' sx={{fontWeight: 600, color: "black"}}>
                    {t("common.functions")}
                </Typography>
                <Grid className={'align-left'} size={{xs: 12, sm: 12 }}>
                    <ButtonSpacer>{addButton}</ButtonSpacer>
                </Grid>
                <Grid size={{xs: 12, sm: 4}}>
                    {state.activeTab !== 'yourFunctions' &&
                        <CompDropdownNew
                            label={t('common.municipality')}
                            selectedValue={props.selectedMunicipality.id}
                            className={'function-dropdown'}
                            rows={getMunicipalityOptions()}
                            name="municipalityId"
                            onChange={handleMunicipalityChange}
                        />
                    }
                </Grid>
                <Grid size={{xs: 12, sm: 4}}>
                    <CompDropdownNew
                        label={t('function.function_type')}
                        className={'function-dropdown'}
                        selectedValue={state.functionType}
                        rows={[
                            {value: "all", label: t('function.all')},
                            {value: "open", label: t('function.open')},
                            {value: "group", label: t('function.group')},
                            {value: "individual", label: t('function.individual')}
                            ]}
                        name="functionTypeId"
                        onChange={handleFunctionTypeChange}
                    />
                </Grid>
                <Grid size={{xs: 12, sm: 4}}>
                    <CompDropdownNew
                        label={t('function.location')}
                        selectedValue={state.locationId}
                        className={'function-dropdown'}
                        rows={_getSortedLocations(props.locations, props.organizations, props.authenticatedUser, t('components.random_location'))}
                        name="locationId"
                        labelColumn="name"
                        valueColumn="id"
                        onChange={handleLocationChange}
                        hasEmptyOption={false}
                    />
                </Grid>
                <Grid size={{xs: 12, sm: 4}}>
                    <CompTextFieldNew
                        label={t('function.filter')}
                        value={state.filter}
                        isSearch={true}
                        isLabelShrink={true}
                        onChange={handleFilterChange}
                    />
                </Grid>
                <Grid size={{xs: 12, sm: 4}}>
                    <Grid container spacing={2} sx={{paddingLeft: '0px !important', paddingRight: '0px !important'}}>
                        <Grid size={{xs: 12, sm: 6}}>
                            <CompDatePickerNew
                                label={t('function.function_search_dates')}
                                isLabelShrink={true}
                                value={state.startDate}
                                name="startDate"
                                onChange={handleDateChangeStart}
                            />
                        </Grid>
                        <Grid size={{xs: 12, sm: 6}}>
                            <CompDatePickerNew
                                label={t('function.function_search_dates_end')}
                                isLabelShrink={true}
                                value={state.endDate}
                                name="endDate"
                                onChange={handleDateChangeEnd}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={{xs: 12, sm: 4}}>
                    <CompRadioGroup
                        name="activeTab"
                        selected={state.activeTab}
                        rows={[
                            {'value': "history", 'label': props.selectedMunicipality.name + " " + t('common.functions')},
                            {'value': "yourFunctions", 'label': t('function.your_functions')},
                        ]}
                        vertical={false}
                        onChange={((e) => {
                            setState({...state, activeTab: e.target.value})
                        })}/>
                </Grid>
                <Grid size={{xs: 12, sm: 6}}>
                    <ButtonSecondary onClick={resetAll}>{t('function.reset_all')}</ButtonSecondary>
                </Grid>
                <Grid size={12}>
                    <CompFunctionCards
                        municipalities={props.municipalities}
                        functions={state.functions}
                        rowClick={viewFunction}
                        changePage={changePage}
                        actions={cardActionButtons}
                        authenticatedUser={props.authenticatedUser}
                        state={state}
                        updateRowsPerPage={updateRowsPerPage}
                    />
                </Grid>
            </Grid>
        </div>
    );
}

export const FunctionPageForm = connect(
    mapStateToProps,
    mapDispatchToProps
)(withTranslation('translation')(FunctionPage));